import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { WithSearch } from "@elastic/react-search-ui";
import { Fragment, useContext } from "react";
import { FormattedMessage } from "react-intl";
import "@elastic/react-search-ui-views/lib/styles/styles.css";
import { UIStateStoreContext } from "../../stores/uiStateStore";
import { Facets } from "./Facets";
import { SidebarSearchField } from "./SidebarSearchField";
import { ToggleFiltersButton } from "./ToggleFiltersButton";
const SidebarActions = () => {
    const uiStore = useContext(UIStateStoreContext);
    return (_jsx(WithSearch, { mapContextToProps: ({ clearFilters }) => ({ clearFilters }), children: ({ clearFilters }) => {
            function clearAll() {
                if (uiStore.inGlobalSearchMode()) {
                    uiStore.setOpenCategory(undefined);
                }
                uiStore.setOpenCategoryFilters([], true);
                clearFilters();
                uiStore.toggleSidebar();
            }
            return (_jsxs("div", { className: "sidebar-actions", children: [_jsx("button", { type: "button", className: "clear-filters-button", "data-testid": "clearFiltersButton", onClick: clearAll, children: _jsx(FormattedMessage, { id: "actions.clearFilters" }) }), _jsx("button", { type: "button", className: "save-filters-button", "data-testid": "saveFiltersButton", onClick: () => uiStore.toggleSidebar(), children: _jsx(FormattedMessage, { id: "actions.saveFilters" }) })] }));
        } }));
};
/**
 * Renders the search field & facets.
 */
export const SidebarContent = () => {
    const state = useContext(UIStateStoreContext);
    return (_jsx("div", { className: "sui-layout-sidebar__inner", "data-testid": "sidebarContent", children: _jsx(WithSearch, { mapContextToProps: ({ wasSearched, filters }) => ({ wasSearched, filters }), children: ({ wasSearched, filters }) => (_jsxs(Fragment, { children: [_jsxs("h2", { "data-testid": "filterResultsTitle", children: [_jsx(FormattedMessage, { id: "filterSearchResults" }), state.isSidebarToggled() && (_jsx(ToggleFiltersButton, {}))] }), _jsx(SidebarSearchField, { filters: filters }), _jsx("hr", {}), wasSearched && (_jsxs(Fragment, { children: [_jsx(Facets, {}), _jsx("hr", { style: { marginTop: "2rem" } }), _jsx(SidebarActions, {})] }))] })) }) }));
};
